(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rd-pdp-variations"] && !Shopify.designMode) return;
  try {
    (() => {

  if (window.rdVehicleCascadeV5Ready) {
    return;
  }


  window.rdVehicleCascadeV5Ready = true;


  const PICKER_SELECTOR =
    'variant-selects[data-rd-variant-cascade]';


  const FIELD_SELECTOR =
    '[data-rd-cascade-stage]';


  const SELECT_SELECTOR =
    'select[data-rd-cascade-key]';


  /*
    State:

    -1
    Manufacturer only

     0
    Manufacturer selected
    Model visible

     1
    Model selected
    Style visible

     2
    Complete
  */

  const states =
    new Map();



  /* ========================================================
     BASIC HELPERS
     ======================================================== */

  const getPicker = (element) => {

    return element?.closest?.(
      PICKER_SELECTOR
    );

  };


  const getStateKey = (picker) => {

    return (
      picker?.dataset?.section ||
      picker?.id ||
      ''
    );

  };


  const getFields = (picker) => {

    if (!picker) {
      return [];
    }


    return Array
      .from(
        picker.querySelectorAll(
          FIELD_SELECTOR
        )
      )
      .sort(
        (a, b) => {

          return (
            Number(
              a.dataset.rdCascadeStage || 0
            ) -
            Number(
              b.dataset.rdCascadeStage || 0
            )
          );

        }
      );

  };


  const getSelects = (picker) => {

    return getFields(picker)
      .map(
        (field) => {

          return field.querySelector(
            SELECT_SELECTOR
          );

        }
      )
      .filter(Boolean);

  };


  const getRealOptions = (select) => {

    return Array
      .from(
        select?.options || []
      )
      .filter(
        (option) => {

          return !option.hasAttribute(
            'data-rd-placeholder'
          );

        }
      );

  };



  /* ========================================================
     SELECTED ATTRIBUTE HANDLING
     ======================================================== */

  const clearSelectedAttributes = (
    select
  ) => {

    if (!select) {
      return;
    }


    select
      .querySelectorAll(
        'option[selected]'
      )
      .forEach(
        (option) => {

          option.removeAttribute(
            'selected'
          );

        }
      );

  };


  const syncSelectedAttribute = (
    select
  ) => {

    if (!select) {
      return;
    }


    clearSelectedAttributes(
      select
    );


    const selectedOption =
      select.options[
        select.selectedIndex
      ];


    if (
      !selectedOption ||
      selectedOption.hasAttribute(
        'data-rd-placeholder'
      )
    ) {
      return;
    }


    selectedOption.setAttribute(
      'selected',
      'selected'
    );

  };


  const showPlaceholder = (
    select
  ) => {

    if (!select) {
      return;
    }


    const placeholder =
      select.querySelector(
        'option[data-rd-placeholder]'
      );


    if (!placeholder) {
      return;
    }


    select.selectedIndex =
      placeholder.index;

  };



  /* ========================================================
     PURCHASE LOCK
     ======================================================== */

  const disablePurchase = (
    picker
  ) => {

    if (!picker) {
      return;
    }


    picker.classList.add(
      'rd-pdp__variants--incomplete'
    );


    const formId =
      picker.dataset.productFormId;


    const form =
      formId
        ? document.getElementById(
            formId
          )
        : picker
            .closest('product-info')
            ?.querySelector(
              'form[action*="/cart/add"]'
            );


    const variantInput =
      form?.querySelector(
        'input[name="id"]'
      );


    /*
      Clear the ID while fitment is incomplete.

      Don't disable the field because Dawn needs to write
      the resolved variant ID into it once Style is selected.
    */

    if (variantInput) {
      variantInput.value = '';
    }


    const submitButton =
      form?.querySelector(
        '[type="submit"][name="add"]'
      );


    if (submitButton) {

      submitButton.disabled =
        true;


      submitButton.setAttribute(
        'aria-disabled',
        'true'
      );

    }

  };


  const markComplete = (
    picker
  ) => {

    picker?.classList.remove(
      'rd-pdp__variants--incomplete'
    );

  };



  /* ========================================================
     APPLY UI STATE
     ======================================================== */

  const applyState = (
    picker,
    state
  ) => {

    if (
      !picker ||
      !state
    ) {
      return;
    }


    const fields =
      getFields(
        picker
      );


    if (!fields.length) {
      return;
    }


    fields.forEach(
      (field, index) => {

        const select =
          field.querySelector(
            SELECT_SELECTOR
          );


        if (!select) {
          return;
        }


        /*
          Visible progression:

          -1:
          Manufacturer

           0:
          Manufacturer
          Model

           1:
          Manufacturer
          Model
          Style
        */

        if (document.activeElement === select || (field && field.contains && field.contains(document.activeElement))) {
          try { document.activeElement.blur(); } catch(e) {}
        }

        const shouldShow = index <= state.completedIndex + 1;

        field.hidden = !shouldShow;

        if (!shouldShow) {
          clearSelectedAttributes(select);
          showPlaceholder(select);
          select.disabled = true;
          return;
        }

        if (index <= state.completedIndex) {
          select.disabled = false;
          return;
        }

        /*
          Fresh next dropdown.
          Leave on placeholder so customer explicitly chooses an option.
        */
        clearSelectedAttributes(select);
        showPlaceholder(select);
        select.disabled = false;

      }
    );


    const complete =
      state.completedIndex >=
      fields.length - 1;


    if (complete) {

      markComplete(
        picker
      );

    } else {

      disablePurchase(
        picker
      );

    }

  };



  /* ========================================================
     INITIALIZE
     ======================================================== */

  const initializePicker = (
    picker
  ) => {

    if (!picker) {
      return;
    }


    const key =
      getStateKey(
        picker
      );


    const productId =
      picker.dataset.productId ||
      '';


    let state =
      states.get(
        key
      );


    /*
      IMPORTANT:
      Every fresh V1 vehicle picker must begin with NO vehicle
      value selected, even if Shopify resolved a variant from the
      incoming product URL.

      Once the customer makes a choice, `states` survives Dawn's
      section re-render and the normal Manufacturer -> Model ->
      Style progression continues without being reset.
    */
    if (
      !state ||
      state.productId !== productId
    ) {

      state = {
        productId,
        completedIndex: -1
      };


      states.set(
        key,
        state
      );

    }


    applyState(
      picker,
      state
    );

  };



  /* ========================================================
     CHANGE
     ======================================================== */

  document.addEventListener(
    'change',

    (event) => {

      const picker =
        getPicker(
          event.target
        );


      if (!picker) {
        return;
      }


      const selects =
        getSelects(
          picker
        );


      const target =
        event.target;


      const targetIndex =
        selects.indexOf(
          target
        );


      if (targetIndex === -1) {
        return;
      }


      const key =
        getStateKey(
          picker
        );


      let state =
        states.get(
          key
        );


      if (!state) {

        state = {
          productId:
            picker.dataset.productId || '',

          completedIndex: -1
        };


        states.set(
          key,
          state
        );

      }



      /* ====================================================
         PLACEHOLDER SELECTED
         ==================================================== */

      if (target.value === '') {

        event.stopImmediatePropagation();


        clearSelectedAttributes(
          target
        );


        state.completedIndex =
          targetIndex - 1;


        selects.forEach(
          (select, index) => {

            if (
              index >=
              targetIndex
            ) {

              clearSelectedAttributes(
                select
              );


              showPlaceholder(
                select
              );

            }

          }
        );


        applyState(
          picker,
          state
        );


        return;

      }



      /* ====================================================
         REAL VALUE
         ==================================================== */

      syncSelectedAttribute(
        target
      );


      state.completedIndex =
        targetIndex;



      /*
        Manufacturer:
        clear Model + Style.

        Model:
        clear Style.
      */

      selects.forEach(
        (select, index) => {

          if (
            index <=
            targetIndex
          ) {
            return;
          }


          clearSelectedAttributes(
            select
          );


          showPlaceholder(
            select
          );


          select.disabled =
            true;

      });



      /*
        Hide stale downstream fields while Dawn fetches
        newly calculated Shopify availability.
      */

      getFields(
        picker
      ).forEach(
        (field, index) => {

          if (
            index >
            targetIndex
          ) {

            field.hidden =
              true;

          }

        }
      );


      /*
        Do not stop propagation here.

        Dawn receives the valid selection and performs its
        normal Section Rendering request.
      */

    },

    true
  );



  /* ========================================================
     DAWN RE-RENDER WATCHER

     Dawn replaces variant-selects after each valid selection.

     State survives that replacement and the next dropdown
     is revealed on the fresh server HTML.
     ======================================================== */

  const mutationObserver =
    new MutationObserver(
      (mutations) => {

        mutations.forEach(
          (mutation) => {

            mutation.addedNodes.forEach(
              (node) => {

                if (
                  !(node instanceof Element)
                ) {
                  return;
                }


                if (
                  node.matches(
                    PICKER_SELECTOR
                  )
                ) {

                  initializePicker(
                    node
                  );

                }


                node
                  .querySelectorAll?.(
                    PICKER_SELECTOR
                  )
                  .forEach(
                    initializePicker
                  );

              }
            );

          }
        );

      }
    );


  mutationObserver.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );



  /* ========================================================
     INITIAL PAGE LOAD
     ======================================================== */

  const initAll = (
    root = document
  ) => {

    if (
      root.matches?.(
        PICKER_SELECTOR
      )
    ) {

      initializePicker(
        root
      );

    }


    root
      .querySelectorAll?.(
        PICKER_SELECTOR
      )
      .forEach(
        initializePicker
      );

  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',

      () => {

        initAll(
          document
        );

      },

      {
        once: true
      }
    );

  } else {

    initAll(
      document
    );

  }



  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',

    (event) => {

      initAll(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',

    (event) => {

      const picker =
        event.target.querySelector?.(
          PICKER_SELECTOR
        );


      if (!picker) {
        return;
      }


      const key =
        getStateKey(
          picker
        );


      states.delete(
        key
      );

    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
